export default __webpack_public_path__ + "static/media/Logo.5836d02c.png";